module.exports = __webpack_public_path__ + "assets/img/AllBoxBtn.01021771.png";